import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
export function Tomos() {
  const tomos = [{
    number: '01',
    title: 'BIOMECÁNICA APLICADA',
    description: 'Planos, ejes, palancas, marcha, fuerzas, centro de gravedad y casos clínicos resueltos.',
    pages: '20 pág.'
  }, {
    number: '02',
    title: 'AGENTES FÍSICOS',
    description: 'Termoterapia, crioterapia, electroterapia, ultrasonido, láser con parámetros completos.',
    pages: '20 pág.'
  }, {
    number: '03',
    title: 'FISIOLOGÍA DEL MOVIMIENTO',
    description: 'Sarcómero, contracción muscular, sistemas energéticos, fibras y unidad motora.',
    pages: '20 pág.'
  }, {
    number: '04',
    title: 'EVALUACIÓN KINÉSICA',
    description: 'Goniometría, Daniels, tests especiales, escalas y diagnóstico kinésico completo.',
    pages: '20 pág.'
  }, {
    number: '05',
    title: 'CLÍNICA TRAUMATOLÓGICA',
    description: 'Hombro, rodilla, columna, cadera y tobillo con protocolos de rehabilitación por lesión.',
    pages: '20 pág.'
  }, {
    number: '06',
    title: 'CLÍNICA NEUROLÓGICA Y RESPIRATORIA',
    description: 'ACV, Parkinson, EPOC, ARM y rehabilitación cardiorrespiratoria paso a paso.',
    pages: '20 pág.'
  }, {
    number: '07',
    title: 'CASOS CLÍNICOS RESUELTOS I',
    description: 'Traumatología y neurología: razonamiento clínico completo con diagnóstico y plan.',
    pages: '20 pág.'
  }, {
    number: '08',
    title: 'CASOS CLÍNICOS RESUELTOS II',
    description: 'Respiratoria, reumatología y clínica mixta con casos de alta complejidad resueltos.',
    pages: '20 pág.'
  }, {
    number: '09',
    title: 'GUÍAS DE PRÁCTICAS HOSPITALARIAS',
    description: 'Cómo leer la HC, signos vitales en sala, UTI, guardia y conducta frente al médico.',
    pages: '20 pág.'
  }, {
    number: '10',
    title: 'TPs Y TRABAJOS PRÁCTICOS LISTOS',
    description: 'Modelos de TPs resueltos listos para adaptar y presentar con el formato que piden.',
    pages: '20 pág.'
  }, {
    number: '11',
    title: 'PREPARACIÓN PARA FINALES',
    description: 'Preguntas frecuentes con respuestas modelo y el vocabulario técnico que sube la nota.',
    pages: '20 pág.'
  }, {
    number: '12',
    title: 'TOMO ESPECIAL DE CIERRE',
    description: 'Anatomía, farmacología, ética, legislación y portfolio para tu primer año profesional.',
    pages: '20 pág.'
  }];
  const checkmarks = ['Protocolos y parámetros clínicos listos para exámenes', 'Casos clínicos resueltos paso a paso por región', 'Ejercicios graficados en cada tomo', 'Checklists de evaluación kinésica por área', 'Resúmenes y mnemotecnias por unidad', 'Lenguaje adaptado al docente argentino'];
  return <section className="w-full bg-slate-50 py-12 md:py-20 px-4" data-id="element-347">
      <div className="max-w-7xl mx-auto" data-id="element-348">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-349">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-350">
            📚 LOS 12 TOMOS — Toda la carrera en un solo lugar
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12" data-id="element-351">
          {tomos.map((tomo, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} className="bg-white p-6 rounded-lg shadow-md border border-slate-200 hover:shadow-xl transition-shadow" data-id="element-352">
              <div className="flex items-start gap-3 mb-3" data-id="element-353">
                <span className="text-3xl font-bold text-[#F0C040]" data-id="element-354">
                  {tomo.number}
                </span>
                <div data-id="element-355">
                  <h3 className="font-bold text-slate-900 text-lg mb-2" data-id="element-356">
                    {tomo.title}
                  </h3>
                  <p className="text-slate-600 text-sm leading-relaxed mb-3" data-id="element-357">
                    {tomo.description}
                  </p>
                  <p className="text-slate-500 text-sm font-medium" data-id="element-358">
                    {tomo.pages}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} className="bg-green-50 border border-green-200 rounded-lg p-6 md:p-8" data-id="element-359">
          <div className="grid md:grid-cols-2 gap-4" data-id="element-360">
            {checkmarks.map((item, i) => <div key={i} className="flex items-start gap-3" data-id="element-361">
                <Check className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" data-id="element-362" />
                <span className="text-slate-700" data-id="element-363">{item}</span>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}